import { SubmissionSlotData } from "types/SubmissionSlots";

import { RootState } from "store/store";
import { StateFn } from "store/types";

import { SubmissionSlotDetailsState } from "./submissionSlotDetailsStore";
import { ValidationStatus } from "./types";

const getStore = (state: RootState): SubmissionSlotDetailsState =>
  state.dataCollection.submissionSlotDetails;

// Selectors

const currentSubmissionSlotData: StateFn<SubmissionSlotData | null> = (
  state: RootState
) => getStore(state).currentSubmissionSlotData;

const enableLoading: StateFn<boolean> = (state: RootState) =>
  getStore(state).enableLoading;

const pristine: StateFn<boolean> = (state: RootState) =>
  getStore(state).pristine;

const isSubmitVisible: StateFn<boolean> = (state: RootState) =>
  getStore(state).isSubmitVisible;

const validationStatus: StateFn<ValidationStatus> = (state: RootState) =>
  getStore(state).validationStatus;

const status: StateFn<string | undefined> = (state: RootState) =>
  getStore(state).status;

const dataTaskPreviousState: StateFn<boolean> = (state: RootState) =>
  getStore(state).dataTaskPreviousState;

export const submissionSlotDetailsSelectors = {
  currentSubmissionSlotData,
  enableLoading,
  pristine,
  isSubmitVisible,
  validationStatus,
  dataTaskPreviousState,
  status,
};
